var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaceholder = function SvgPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 126,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.698 21h3.552c8.698 0 15.75 7.052 15.75 15.75v63c0 8.699-7.052 15.75-15.75 15.75h-94.5a15.76 15.76 0 0 1-4.21-.569L21.6 105h88.65a5.25 5.25 0 0 0 5.25-5.25v-63a5.25 5.25 0 0 0-5.25-5.25H96.06L106.699 21zm-96.147 79.485a5.303 5.303 0 0 1-.051-.735v-63c0-2.9 2.35-5.25 5.25-5.25h64.668L91.052 21H15.75C7.052 21 0 28.052 0 36.75v63c0 3.182.943 6.143 2.566 8.619l7.985-7.884z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.742 51.556C80.762 55.394 84 61.444 84 68.25c0 11.598-9.402 21-21 21-6.904 0-13.03-3.332-16.858-8.475l7.623-7.525A10.498 10.498 0 0 0 63 78.75c5.799 0 10.5-4.701 10.5-10.5 0-3.94-2.17-7.373-5.38-9.17l7.622-7.524zM42.031 69.402c-.02-.381-.031-.765-.031-1.152 0-11.598 9.402-21 21-21 .477 0 .95.016 1.419.047L42.03 69.402zM85.72 26.265l7.932-7.832-3.324-7.123a10.5 10.5 0 0 0-9.515-6.06H45.187a10.5 10.5 0 0 0-9.515 6.06L26.25 31.5h11.587l7.35-15.75h35.626l4.907 10.515zM96.06 31.5l2.526-2.493L99.75 31.5h-3.69z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.663 19.913a5.25 5.25 0 0 0-7.425-7.425L10.313 114.413a5.25 5.25 0 0 0 7.425 7.425L119.663 19.913z"
  }))));
};
export default SvgPlaceholder;